import React from 'react';

const DemoBanner = () => {
  // Only show in demo mode
  if (process.env.REACT_APP_IS_DEMO !== 'true') return null;

  return (
    <div style={{
      background: 'linear-gradient(90deg, #f39c12, #e74c3c)',
      color: 'white',
      padding: '10px 16px',
      textAlign: 'center',
      fontSize: '14px',
      fontWeight: '500',
      position: 'relative',
      zIndex: 1000
    }}>
      <span style={{ marginRight: '8px' }}>Demo Mode</span>
      <span style={{ opacity: 0.9 }}>- Data resets every 6 hours</span>
      <a
        href="https://zenbidtracker.com/signup"
        style={{
          color: 'white',
          marginLeft: '16px',
          textDecoration: 'underline',
          fontWeight: '600'
        }}
      >
        Sign up for full version
      </a>
    </div>
  );
};

export default DemoBanner;
